<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="packingPositionLightUp" :tab="$t('tab.lightUp')" style="margin-top: -14px">
        <packingPositionLightUp ref="packingPositionLightUp"/>
      </a-tab-pane>
      <a-tab-pane key="packingPositionLightOff" :tab="$t('tab.lightOff')" forceRender style="margin-top: -14px">
        <packingPositionLightOff ref="packingPositionLightOff"/>
      </a-tab-pane>
      <a-space v-if="activeKey === 'packingPositionLightUp'" slot="tabBarExtraContent">
        <a-button type="primary" @click="getData">{{ $t('button.refresh') }}</a-button>
        <a-button type="primary" @click="lightUp">{{ $t('button.lightUp') }}</a-button>
      </a-space>
      <a-space v-else slot="tabBarExtraContent">
        <a-button type="primary" @click="getData">{{ $t('button.refresh') }}</a-button>
        <a-button type="primary" @click="lightOff">{{ $t('button.lightOff') }}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>
<script>
  import PackingPositionLightUp from '@/views/outbound/packing_position_monitor/PackingPositionLightUp.vue'
  import PackingPositionLightOff from '@/views/outbound/packing_position_monitor/PackingPositionLightOff.vue'

  export default {
    name: 'PackingPositionMonitor',
    components: {PackingPositionLightUp, PackingPositionLightOff},
    data() {
      return {
        activeKey: 'packingPositionLightUp'
      }
    },
    methods: {
      getData() {
        this.$refs[this.activeKey].getData()
      },
      lightUp() {
        this.$refs.packingPositionLightUp.lightUp()
      },
      lightOff() {
        this.$refs.packingPositionLightOff.lightOff()
      }
    }
  }
</script>